import { Editor, track } from '@tldraw/tldraw'
import { ButtonGroup } from './ButtonGroup'
import { Button } from 'common/Prose/Toolbar/ToolbarBravo/WriterFormatToolbar/Button'
import { FlipLeft, FlipRight } from 'blaze-ui/icons'
import { useActions } from '../VisualEditor/hooks/useActions'

interface Props {
  editor: Editor
}

export const HistoryButtonGroup = track(({ editor }: Props) => {
  const actions = useActions(editor)

  return (
    <ButtonGroup>
      <Button
        aria-label="Undo"
        icon={FlipLeft}
        onPress={() => actions['undo'].onSelect()}
        isDisabled={!editor.getCanUndo()}
      />
      <Button
        aria-label="Redo"
        icon={FlipRight}
        onPress={() => actions['redo'].onSelect()}
        isDisabled={!editor.getCanRedo()}
      />
    </ButtonGroup>
  )
})
